import { render, staticRenderFns } from "./DiagnosisDetail.vue?vue&type=template&id=7a7e3f5a&scoped=true"
import script from "./DiagnosisDetail.vue?vue&type=script&lang=js"
export * from "./DiagnosisDetail.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisDetail.vue?vue&type=style&index=0&id=7a7e3f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7e3f5a",
  null
  
)

export default component.exports